// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2-JgM","box":"WorkspacesBox_box__1nd6m","node":"WorkspacesBox_node__362C_"};